enum PageSizeOptionEnum {
  Twenty = 20,
  Fifty = 50,
  OneHundred = 100,
}

export default PageSizeOptionEnum;
